import { render, staticRenderFns } from "./Carousel.Default.vue?vue&type=template&id=8f231766&scoped=true&"
import script from "./Carousel.Default.vue?vue&type=script&lang=js&"
export * from "./Carousel.Default.vue?vue&type=script&lang=js&"
import style0 from "./Carousel.Default.vue?vue&type=style&index=0&id=8f231766&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f231766",
  null
  
)

export default component.exports